<template>
  <CRow>
    <CCol lg="12" md="12" sm="12">
      <CCard>
        <CCardHeader>
          <strong>Quản lý sản phẩm đã sản xuất</strong>
          <div class="card-header-actions">
            <CButton v-if="detail" type="button"
                     shape="pill" color="info" class="mr-1"
                     @click="requestProductDate">
              <CIcon name="cil-filter" class="mr-1"/>Lọc theo ngày</CButton>

            <CButton v-if="detail" type="button" shape="pill" color="secondary" class="mr-1" @click="goBack">
              <CIcon name="cil-chevron-left"/>
              Quay lại</CButton>
          </div>
        </CCardHeader>
        <CCardBody class="pt-1">
          <p v-if="currentItems && currentItems.length > 0" class="pb-0 mb-0">Số lượng: <strong>{{ formatNumber(currentItems.length) }}</strong></p>
          <CRow v-if="detail">
            <CCol>
              <CInput type="date" label="Sản xuất từ ngày:"
                      v-model="startDate"
                      :addLabelClasses="'text-right'"
                      :max="todayStr"
              />
            </CCol>
            <CCol>
              <CInput type="date" label="Đến ngày:"
                      v-model="stopDate"
                      :max="todayStr"
                      :addLabelClasses="'text-right'"/>
            </CCol>
            <CCol>

            </CCol>
          </CRow>

          <CDataTable
            :items="currentItems"
            :fields="getCurrentFields"
            :tableFilter="{label :'Bộ lọc: ', placeholder:'Nội dung' }"
            :itemsPerPageSelect="{label:' ', values: ['10', '100', '200']}"
            :itemsPerPage="100"
            column-filter
            hover
            sorter
            pagination
            clickable-rows
            @row-clicked="rowClicked"
          >
            <template #no-items-view>
              <div style="color: #888; text-align: center; padding: 10px; font-style: italic;">
                Danh sách trống!
              </div>
            </template>
            <template #stt="{item, index}">
              <td class="py-2">
                {{index+1}}
              </td>
            </template>
            <template #produced="{item}">
              <td class="py-2 text-right">
                {{formatNumber(item.produced)}}
              </td>
            </template>

          </CDataTable>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>

export default {
  data() {
    const today = new Date();
    const past = new Date();
    past.setMonth(past.getMonth() - 1);
    const startStr=past.toISOString().split("T")[0]
    const stopStr=today.toISOString().split("T")[0]
    return {
      detail: false,
      isSuper: false,
      userName: '',
      userRole: '',
      currentItems: [],
      // Define the table fields
      allTypeFields: [
        { key: 'stt', label: 'Stt', _style:'width:3rem;' },
        { key: 'product', label: 'Tên sản phẩm', _classes: 'font-weight-bold' },
        { key: 'description', label: 'Mô tả' },
        { key: 'produced', label: 'Đã sản xuất', _style: 'text-align: center;' },
        // { key: 'delivered', label: 'Đã giao hàng' },
        { key: 'note', label: 'Ghi chú' },
      ],
      productFileds: [
        { key: 'stt', label: 'Stt', _style:'width:3rem;' },
        { key: 'product', label: 'Tên sản phẩm', _classes: 'font-weight-bold' },
        { key: 'uuid', label: 'Seri' },
        { key: 'app_crc', label: 'App CRC' },
        //{ key: 'mac', label: 'MAC' },
        //{ key: 'code', label: 'Code' },
        //{ key: 'project', label: 'Lô sản xuất' },
        //{ key: 'lic_key', label: 'license' },
        { key: 'date', label: 'Ngày SX' },
        { key: 'who', label: 'Thực hiện' },
        //{ key: 'factory', label: 'Nhà máy' },
        { key: 'note', label: 'Ghi chú' },
        { key: 'detail', label: 'Chi tiết' },
      ],
      withProject: '',
      darkModal: false,
      utilities: {
        mode: 'Tạo ECODE',
        start: '',
        count: 0,
      },
      projectsUseProduct: [],
      currentProduct: '',
      targetProject: '',
      startDate: startStr,
      stopDate: stopStr,
      todayStr: new Date().toISOString().split("T")[0],
    };
  },
  computed: {
    getCurrentFields() {
      return this.detail ? this.productFileds : this.allTypeFields
    },
    validToUpdate: function () {
      if (!this.targetProject || !this.currentProduct) {
        return false;
      }
      const today = new Date().toISOString().split("T")[0];
      const date0 = Date.parse(today);
      const date1 = Date.parse(this.startDate);
      const date2 = Date.parse(this.stopDate);
      return date1 <= date2 && date2 <= date0;
    }
  },
  created() {
    this.getSuper()
    this.getProductTypes()
  },
  watch: {
    startDate(newVal) {
      if (this.detail && this.currentProduct) {
        this.requestProductDate()
      }
    },
    stopDate(newVal) {
      if (this.detail && this.currentProduct) {
        this.requestProductDate()
      }
    }
  },
  methods: {
    getSuper() {
      this.userRole = localStorage.getItem('role')
      this.isSuper = ((this.userRole === 'root') || (this.userRole === 'super'))
      this.userName = localStorage.getItem('username')
    },
    getProductTypes() {
      if(this.userRole === 'customer') {
        this.$request.get(`/api/device/products/customer/${this.userName}`).then(res => {
          // console.log(res.data)
          this.currentItems = res.data.products
          this.detail = false
        })
      } else {
        this.$request.get('/api/device/products').then(res => {
          // console.log(res.data)
          this.currentItems = res.data.products
          this.detail = false
        })
      }
    },
    getProducts(name) {
      this.currentProduct=name
      this.$showBusy()
      this.$request.get(`/api/device/products/${name}?start=${this.startDate}&stop=${this.stopDate}`).then(res=>{
        // console.log(res.data)
        this.currentItems = res.data.products
        this.projectsUseProduct= res.data.projectsUseProduct
        this.detail=true
        this.$closeBusy()
      })
    },
    rowClicked(item, index) {
      // console.log('row clicked get item: ', item, ' detail: ', this.detail)
      if(!this.detail) {
        this.getProducts(item.product)
      }
    },
    goBack() {
      this.getProductTypes()
    },
    requestProductDate(){
      this.$request.get(`/api/device/products/${this.currentProduct}?start=${this.startDate}&stop=${this.stopDate}`).then(res=>{
        // console.log(res.data)
        this.currentItems = res.data.products
      })
    },
  },
};
</script>

<style scoped>
.clickable-text {
  cursor: pointer;
  text-decoration: none; /* Default: No underline */
  vertical-align: center;
  font-weight: bold;
}

.clickable-text:hover {
  text-decoration: underline; /* Underline only on hover */
}
</style>
